import Btn from '../utils/btn';

const func = $target => {

	htmx.on($target[0],'htmx:afterSwap', function(event) {
		var $step = $target.find('.card').data('step');

		if($step == 1) {
			window.loader.key('zxcvbn', function() {
				var strengthScore = 0,
					$passwordInput = $target.find('#password'),
					$meter = $target.find('.progress-bar'),
					$text = $target.find('.meter-text');
		
				var strength = {
					0: 'Worst',
					1: 'Bad',
					2: 'Weak',
					3: 'Good',
					4: 'Strong'
				};
				var colours = {
					0: 'bg-danger',
					1: 'bg-danger',
					2: 'bg-warning',
					3: 'bg-success',
					4: 'bg-success'
				};
		
				$passwordInput.on('input', function(e) {
					var val = $passwordInput.val(),
						result = zxcvbn(val),
						$this = $(this);
		
					strengthScore = result.score;
					//console.log(result);
					if (result.score < 1) {
						result.score = 0.2;
						strengthScore = 0;
					}
					if (result.password.length == 0) {
						result.score = 0;
					}
					//if (result.score > 2) {
					//$passwordInput.attr('pattern', '.{6,}');
					//} else {
					//$passwordInput.attr('pattern', '[.]');
					//}
					$meter.width(result.score * 25 + '%');
					$meter.removeClass('bg-danger bg-warning bg-success').addClass(colours[strengthScore]);
		
					if (val !== '') {
						//$text.text(strength[result.score]);
						$text.text(result.feedback.warning);
						//$suggestions.text(result.feedback.warning);
					} else {
						$text.text('');
						//$suggestions.text('');
					}
				});

				var $passwordContainer = $('[data-mod="showPassword"]');

				$passwordContainer.find('.btn').on('click', function(e) {
					e.preventDefault;
					if ($passwordInput.attr('type') == 'password') {
						$passwordInput.attr('type', 'text');
					} else {
						$passwordInput.attr('type', 'password');
					}
				});
			});

			var $country = $target.find('select[name="address[countryId]"]'),
				$taxId = $target.find('#businessTaxId');

			$country.on('change', function(e) {
				if($(this).val() == '68') {
					$taxId.prop('required',true);
					$taxId.attr('placeholder','Tax ID/VAT number');
				} else {
					$taxId.prop('required',false);        
					$taxId.attr('placeholder','Tax ID/VAT number (optional)');    
				}
			});
		}

		if($step == 3 || $step == 'payment') {
			// $('html, body').animate({
            //     scrollTop: $('.order-bump').offset().top - 20
            // }, 'fast');

			var $form = $target.find('[data-id="paymentForm"]'),
				$token = $form.find('[name*="gatewayToken"]'),
				$nonce = $form.find('[name*="nonce"]'),
				amount = $form.find('[name*="amount"]').val(),
				currency = $form.find('[name*="currency"]').val(),
				email = $form.find('[name*="email"]').val(),
				address = JSON.parse($form.find('[name*="address"]').val()),
				$dropinUi = $form.find('[data-id="dropInUi"]'),
				$submit = new Btn($form.find('button[type="submit"]'));

			if ($dropinUi[0]) {

				window.loader.key('braintree-dropinUI', function() {
					$submit.process();
					if ($submit.data('loading')) {
						$submit.text($submit.data('loading'));
					}

					var options = {
						authorization: $token.val(),
						container: $dropinUi[0],
						locale: $dropinUi.data('locale'),
						vaultManager: $dropinUi.data('manage'),
						card: {
							cardholderName: {
								required: true
							},
							vault: {
								vaultCard: true,
								allowVaultCardOverride: true,
							}
						}
					};

					let subscriptionOrder = Boolean($dropinUi.attr('data-subscription'));

					if (subscriptionOrder != true) {
						options.applePay = {
							displayName: $dropinUi.data('name'),
							paymentRequest: {
								total: {
									label: $dropinUi.data('name'),
									amount: amount
								}
							}
						};

						options.googlePay = {
							displayName: $dropinUi.data('name'),
							paymentRequest: {
								total: {
									label: $dropinUi.data('name'),
									amount: amount
								}
							}
						};
					} else {
						options.card.vault.allowVaultCardOverride = false;
					}

					options.paypal = {
						flow: subscriptionOrder == true ? 'vault' : 'checkout' ,
						env: $dropinUi.attr('data-sandbox') ? 'sandbox' : 'production',
						amount: amount,
						currency: currency,
						vault: {
							vaultPayPal: subscriptionOrder,
						},
						buttonStyle: {
							color: 'blue',
							shape: 'rect',
							size: 'responsive',
							label: 'paypal',
						},
					};

					if ($dropinUi.data('threedsecure')) {
						options.threeDSecure = true;
		
						var threeDSecureOptions = {
							amount: amount,
							email: email,
							billingAddress: address,
							challengeRequested: true,
						};
					}

					braintree.dropin.create(options, function(err, dropinInstance) {
						if (err) {
							console.error(err);
							if (window.braintreeError) {
								window.braintreeError(err);
							}
							return;
						}
						//reset($submit);
						$submit.resetText();
						$submit.processed();

						if (dropinInstance.isPaymentMethodRequestable()) {
							//reset($submit);
							//console.log('isPaymentMethodRequestable');
						}
						//need for vault
						dropinInstance.on('paymentMethodRequestable', function(e) {
							//reset($submit);
							//console.log('paymentMethodRequestable');
							$submit.enable();
						});
						dropinInstance.on('noPaymentMethodRequestable', function(e) {
							//processing($submit);
							//console.log('noPaymentMethodRequestable');
							$submit.disable();
						});
						dropinInstance.on('paymentOptionSelected', function(e) {
							//$submit.prop('disabled', false);
							//console.log('paymentOptionSelected');
						});

						$form.on('submit', {
							dropinInstance: dropinInstance,
							threeDSecure: $dropinUi.data('threedsecure'),
							threeDSecureOptions: threeDSecureOptions
						}, formSubmit);
					});
				});
			}

		}

		function formSubmit(e) {
			e.preventDefault();
			//console.log(e)
			var dropinInstance = e.data.dropinInstance,
				$form = $(e.currentTarget),
				threeDSecure = e.data.threeDSecure,
				threeDSecureOptions = e.data.threeDSecureOptions;

			//$submit = $form.find('button[type="submit"]');
			//processing($submit);
			$submit.process();

			var options = {
				threeDSecure: threeDSecureOptions
			}

			dropinInstance.requestPaymentMethod(threeDSecure ? options : {}, function(err, payload) {
				if (err) {
					console.error(err);
					if (window.braintreeError) {
						window.braintreeError(err);
					}
					//reset($submit);
					$submit.processed();
					return;
				}
				//console.log(payload);
				if ((payload.liabilityShiftPossible && payload.liabilityShifted) || !payload.liabilityShiftPossible || payload.type !== 'CreditCard' || !threeDSecure) {
					//processing($submit);
					$submit.process();

					$form.find('input[name*=nonce]').val(payload.nonce);
					$form.find('input[name*=type]').val(payload.type);
					$form.off('submit', formSubmit);
					$form.submit();
				} else {
					if (window.braintreeError) {
						window.braintreeError('3ds failed');
					}
					//dropinInstance.clearSelectedPaymentMethod();
					//reset($submit);
					$submit.processed();
					//$submit.prop('disabled', true);
				}
			});
		}

	});

	htmx.on($target[0],'htmx:beforeRequest', function(event) {
		var $element = event.detail.elt;
		
		if (($element.id).startsWith('selectedOrderBumpId')) {
			var $spinner = $target.find('#spinner_' + $element.value);
			$spinner.removeClass('d-none');
		}

		if ($element.id == 'addToCart' || $element.id == 'registration' || $element.id == 'updateBillingAddress' || $element.id == 'login') {
			var $btn = $target.find('.btn');

			if(!$btn.hasClass('btn-processing')) {
				$btn.addClass('btn-processing');
				$btn.css('opacity',0.65);
			}
		}
	});
	
};

export default func;